import React from "react";
import { Link } from "react-router-dom";

export default function About() {
  return (
    <div className="paper-grain" data-testid="about-page">
      <div className="max-w-3xl mx-auto px-6 pt-20 pb-24">
        <div className="grid grid-cols-12 gap-8">
          <div className="col-span-12 md:col-span-5 fade-up">
            <img
              src="https://images.unsplash.com/photo-1455390582262-044cdead277a?crop=entropy&cs=srgb&fm=jpg&w=900&q=85"
              alt="A fountain pen resting on lined paper"
              className="w-full grayscale hover:grayscale-0 transition-all duration-700 border border-[#D9D2C7]"
              data-testid="about-image"
            />
          </div>
          <div className="col-span-12 md:col-span-7 fade-up fade-up-delay-1">
            <p className="overline">Hello</p>
            <h1 className="font-display text-5xl md:text-6xl tracking-tight mt-3">
              About me.
            </h1>
            <div className="prose-literary mt-6">
              <p>
                Hi, my name is Adrian. I go to primary school in Victoria,
                Australia. This is where I keep my stories and poems for people
                to read and enjoy. They are written slowly and published when
                they are ready, not before.
              </p>
              <p>
                So, keep checking back on readingroom.blog for new writes,
                stories and poems.
              </p>
              <blockquote>
                “A word after a word after a word is power.” — Margaret Atwood
              </blockquote>
            </div>
            <Link to="/" className="btn-ghost inline-block mt-8" data-testid="about-cta">
              Begin Reading
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
